import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import { useParams } from "react-router-dom";

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Button, Card, CardContent } from '@mui/material';
import { useHistory } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { ThemeProvider as ThemeProviderV4, createMuiTheme } from '@material-ui/core/styles';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import { returnDescricaoInsumo } from '../../../../../utils/insumoHelpers';


const getDropzoneStyles = (darkMode) => ({
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
    backgroundColor: darkMode ? '#2d2d2d' : '#fafafa',
    color: darkMode ? '#fff' : '#000',
});


export default function CadastrarEquipamento() {

    const darkMode = Cookies.get('darkMode') === 'true';

    const regra = Cookies.get('regra') || '';
    const isCliente = regra.toUpperCase().includes("CLIENTE") || regra.toUpperCase().includes("ASSOC_") || regra.toUpperCase().includes("COLABORADOR") || regra.toUpperCase().includes("MONITOR");

    const theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: '#1976d2',
            },
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
        },
    });

    const themeV4 = createMuiTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: {
                main: '#1976d2',
            },
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
            }
        },
    });

    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);

    }


    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);


    const [ip, setIp] = useState(null);
    const [porta, setPorta] = useState(null);
    const [protocolo, setProtocolo] = useState(0);
    const [cameraUsuario, setCameraUsuario] = useState('admin');
    const [cameraSenha, setCameraSenha] = useState('');
    const [cameraStatus, setCameraStatus] = useState(1);
    const [cameraZona, setCameraZona] = useState('');
    const [busca1, setBusca1] = useState('MEMORIA_CAMERA_RTSP');
    const [busca2, setBusca2] = useState('MEMORIA_CAMERA_HTTP');
    const [busca3, setBusca3] = useState('NVR');
    const [busca4, setBusca4] = useState('LOCAL');

    const [canalGravacao, setCanalGravacao] = useState(0);
    const [temperaturaMinima, setTemperaturaMinima] = useState(0.0);
    const [temperaturaMaxima, setTemperaturaMaxima] = useState(100.0);
    const [emissividade, setEmissividade] = useState(0.95);
    const [unidadeTemperatura, setUnidadeTemperatura] = useState(0);
    const [listaNegraLpr, setListaNegraLpr] = useState('');
    const [listaBrancaLpr, setListaBrancaLpr] = useState('');
    const [presetAlarme, setPresetAlarme] = useState(1);
    const [velocidadePtz, setVelocidadePtz] = useState(5);

    const [modelo, setModelo] = useState(null);
    const [numeroSerie, setNumeroSerie] = useState(null);





    function returnDescricaoStatus(status_item) {
        var texto = "";

        if (status_item === 0) {
            texto = "Disponível";
        }
        else if (status_item === 1) {
            texto = "Alugado";
        }
        else if (status_item === 2) {
            texto = "Vendido";
        }
        else if (status_item === 3) {
            texto = "Emprestado";
        }

        return texto
    }



    function returnDescricaoItemEstoque(item) {

        return "ID: " + item.id_item_estoque + "<br />" +
            "Status: " + returnDescricaoStatus(item.status_item) + "<br />" +
            "Fornecedor: " + (item.item.cotacao.fornecedor.tipo_fornecedor === 0 ? (item.item.cotacao.fornecedor.nome + " " + item.item.cotacao.fornecedor.sobrenome) : item.item.cotacao.fornecedor.nome_fantasia) + "<br />";


    }







    const { flagBack } = useParams();
    const { idCliente } = useParams();
    const { idInstalacao } = useParams();



    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const [instalacao, setInstalacao] = useState(null);
    const [botaoClicado, setBotaoClicado] = useState(false);


    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [nomeMapa, setNomeMapa] = useState("");
    const [iconeMapa, setIconeMapa] = useState(0);

    const [ramal, setRamal] = useState("");
    const [localizacao, setLocalizacao] = useState("");

    const [posicaoInstalacao, setPosicaoInstalacao] = useState(0);
    const [delayRegistro, setDelayRegistro] = useState(10);

    const handleIconeMapa = (event) => {
        setIconeMapa(event.target.value);
    };

    const [modulosSonoros, setModulosSonoros] = useState(null);

    const [moduloSonoroSelecionado, setModuloSonoroSelecionado] = useState(null);





    const handleItemEstoque = (item_estoque) => {
        setItemEstoqueSelecionado(item_estoque);

    }







    const [modulosPgms, setModulosPgms] = useState(null);

    const [moduloPgmSelecionado, setModuloPgmSelecionado] = useState(null);

    const [modulosPgmsAssociados, setModulosPgmsAssociados] = useState([]);
    const [modulosSonorosAssociados, setModulosSonorosAssociados] = useState([]);

    const [modulosGateways, setModulosGateways] = useState([]);
    const [moduloGatewaySelecionado, setModuloGatewaySelecionado] = useState(null);

    const [modulosSentinel, setModulosSentinel] = useState([]);
    const [moduloSentinelSelecionado, setModuloSentinelSelecionado] = useState(null);

    const salvar = () => {
        // Verifica se o botão já foi clicado
        if (!botaoClicado) {
            // Executa a lógica do clique aqui
            console.log('Botão clicado!');

            // Atualiza o estado para indicar que o botão foi clicado
            setBotaoClicado(true);
            funcaoSalvar();
        }
    };



    const history = useHistory();


    function limparSemelhante() {

        setRamal("");
        setLocalizacao("");
        setNumeroSerie("");
        setLatitude("");
        setLongitude("");
        setBotaoClicado(false);
        setPosicaoInstalacao(0);
        setDelayRegistro(10);

    }


    function limparDiferente() {
        setIp("");
        setPorta("");
        setRamal("");
        setLocalizacao("");
        setNumeroSerie("");
        setLatitude("");
        setLongitude("");
        setBotaoClicado(false);
        setInsumoSelecionado(null);
        setModuloGatewaySelecionado(null);
        setModuloSentinelSelecionado(null);
        setPosicaoInstalacao(0);
        setDelayRegistro(10);

    }


    async function handleClickCriarRamal() {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token"),
                'Content-Type': 'application/json'
            };

            const url = `/v1/protected/equipamentos/criarramal/${ramal}`;

            const response = await api.post(url, {}, { headers });

            // Sucesso
            const msg = response.data?.message || response.data || "Ramal criado com sucesso!";
            alert(msg);

        } catch (error) {

            // Erro do backend (mensagem enviada pelo seu ResponseEntity)
            if (error.response) {
                const msg = error.response.data?.message
                    || error.response.data
                    || "Erro ao criar ramal";
                alert("❌ Falha: " + msg);
            } else {
                // Erro de rede ou outro inesperado
                alert("❌ Erro inesperado: " + error.message);
            }

        }
    }


    async function funcaoSalvar() {


        const cadastro = {
            latitude: latitude,
            longitude: longitude,
            nome_mapa: nomeMapa,
            ip: ip,
            porta: porta,
            tipo_equipamento_area_tecnica: insumoSelecionado.tipo_equipamento_area_tecnica,
            localizacao: localizacao,
            numero_serie: numeroSerie,
            modelo: modelo,
            posicao_instalacao: posicaoInstalacao,
            delay_registro: delayRegistro,

        }

        try {

            if (insumoSelecionado) {
                cadastro.id_insumo = insumoSelecionado.insumo.id_insumo;
            } else {
                alert("Selecione o Insumo!");
                return;
            }

            if (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 8) {
                if (posicaoInstalacao === null || posicaoInstalacao === undefined) {
                    alert("Selecione a Posição da Instalação do Sensor!");
                    setBotaoClicado(false);
                    return;
                }
                if (!delayRegistro || delayRegistro < 10) {
                    alert("O Delay de Registro deve ser um número maior ou igual a 10!");
                    setBotaoClicado(false);
                    return;
                }
            }



            if (itemEstoqueSelecionado) {
                cadastro.id_item_estoque = itemEstoqueSelecionado.id_item_estoque;
            }


            //modulo pgm
            if (moduloPgmSelecionado?.id_modulo_pgm) {
                cadastro.modulo_pgm = { id_modulo_pgm: moduloPgmSelecionado.id_modulo_pgm };
            }

            //modulo pgm
            if (moduloSonoroSelecionado?.id_modulo_sonoro) {
                cadastro.modulo_sonoro = { id_modulo_sonoro: moduloSonoroSelecionado.id_modulo_sonoro };
            }
            if (insumoSelecionado && (
                (insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80) ||
                (parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80)
            )) {
                if (moduloPgmSelecionado?.id_modulo_pgm && parseInt(protocolo, 10) === 0) {
                    if (!ip || ip.trim() === "") {
                        alert("Para configurar a câmera Hikvision no Módulo PGM, preencha o campo IP!");
                        setBotaoClicado(false);
                        return;
                    }
                    if (!cameraUsuario || cameraUsuario.trim() === "") {
                        alert("Para configurar a câmera Hikvision no Módulo PGM, preencha o Usuário da Câmera!");
                        setBotaoClicado(false);
                        return;
                    }
                    if (!cameraSenha || cameraSenha.trim() === "") {
                        alert("Para configurar a câmera Hikvision no Módulo PGM, preencha a Senha da Câmera!");
                        setBotaoClicado(false);
                        return;
                    }
                    if ((!cameraZona || cameraZona.trim() === "") && (!nomeMapa || nomeMapa.trim() === "")) {
                        alert("Para configurar a câmera Hikvision no Módulo PGM, preencha a Zona / Nome da Câmera!");
                        setBotaoClicado(false);
                        return;
                    }
                }

                cadastro.canal_gravacao = parseInt(canalGravacao, 10) || 0;
                cadastro.temperatura_minima = parseFloat(temperaturaMinima) || 0.0;
                cadastro.temperatura_maxima = parseFloat(temperaturaMaxima) || 100.0;
                cadastro.emissividade = parseFloat(emissividade) || 0.95;
                cadastro.unidade_temperatura = parseInt(unidadeTemperatura, 10) || 0;
                cadastro.lista_negra_lpr = listaNegraLpr || "";
                cadastro.lista_branca_lpr = listaBrancaLpr || "";
                cadastro.preset_alarme = parseInt(presetAlarme, 10) || 1;
                cadastro.velocidade_ptz = parseInt(velocidadePtz, 10) || 5;

                cadastro.camera = {
                    usuario: cameraUsuario,
                    senha: cameraSenha,
                    status: cameraStatus,
                    protocolo: parseInt(protocolo, 10),
                    zona: cameraZona,
                    busca_prioridade_1: busca1,
                    busca_prioridade_2: busca2,
                    busca_prioridade_3: busca3,
                    busca_prioridade_4: busca4,
                    canal_gravacao: parseInt(canalGravacao, 10) || 0,
                    temperatura_minima: parseFloat(temperaturaMinima) || 0.0,
                    temperatura_maxima: parseFloat(temperaturaMaxima) || 100.0,
                    emissividade: parseFloat(emissividade) || 0.95,
                    unidade_temperatura: parseInt(unidadeTemperatura, 10) || 0,
                    lista_negra_lpr: listaNegraLpr || "",
                    lista_branca_lpr: listaBrancaLpr || "",
                    preset_alarme: parseInt(presetAlarme, 10) || 1,
                    velocidade_ptz: parseInt(velocidadePtz, 10) || 5
                };
            }

            //modulo gateway
            if (moduloGatewaySelecionado?.id_modulo_gateway) {
                cadastro.modulo_gateway = { id_modulo_gateway: moduloGatewaySelecionado.id_modulo_gateway };
            }

            //modulo sentinel
            if (moduloSentinelSelecionado?.id_modulo_sentinel) {
                cadastro.modulo_sentinel = { id_modulo_sentinel: moduloSentinelSelecionado.id_modulo_sentinel };
            }

            //ramal

            if (



                (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 120)
                ||
                (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 130)



            ) {
                cadastro.ramal = ramal;
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/equipamentos/cadastrar/' + idInstalacao + "/" + insumoSelecionado.insumo.tipo_equipamento_area_tecnica, cadastro,
                { headers: headers });
            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                const escolha = window.prompt(
                    "Selecione uma opção:\n1 - Finalizar cadastro de equipamentos\n2 - Novo equipamento semelhante\n3 - Novo equipamento diferente"
                );

                switch (escolha) {
                    case "1":
                        alert("Equipamento Cadastrado");
                        if (parseInt(flagBack) === 1) {
                            history.push({
                                pathname:
                                    "/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/" +
                                    idInstalacao +
                                    "/" +
                                    idCliente,
                            });
                        }
                        break;
                    case "2":
                        limparSemelhante();
                        break;
                    case "3":
                        limparDiferente();
                        break;
                    default:

                }
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }

        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setBotaoClicado(false);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }



    const [clienteSelecionado, setClienteSelecionado] = useState();

    const [clientes, setClientes] = useState();

    const [loading, setLoading] = useState(true);


    const [itemEstoqueSelecionado, setItemEstoqueSelecionado] = useState(null);

    const handleCliente = (event, cliente) => {

        setClienteSelecionado(cliente);
    };



    function returnDescricaoCliente(cliente) {
        var texto = "ID: " + cliente.id_cliente + " " +
            (cliente.tipo_cliente === 0 ? ("CPF: " + cliente.cpf) : ("CNPJ: " + cliente.cnpj)) + " " +
            (cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) : cliente.nome_fantasia);

        return texto;
    }


    function returnDescricaoInstalacao(instalacao) {
        var texto = "ID_Integrador: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }



    function returnDescricaoModuloPgm(modulo) {
        var texto = "ID: " + modulo.id_modulo_pgm + "\n Código: " + modulo.codigo;
        return texto;
    }


    function returnDescricaoModuloSonoro(modulo) {
        var texto = "ID: " + modulo.id_modulo_sonoro + "\n Código: " + modulo.codigo;
        return texto;
    }

    function returnDescricaoModuloGateway(modulo) {
        var texto = "ID: " + modulo.id_modulo_gateway + "\n Código: " + modulo.codigo;
        return texto;
    }

    function returnDescricaoModuloSentinel(modulo) {
        var texto = "ID: " + modulo.id_modulo_sentinel + "\n Código: " + modulo.codigo;
        return texto;
    }



    async function listarInformacoes() {


        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            let id_cliente = parseInt(idCliente);
            let id_instalacao = parseInt(idInstalacao);
            let flag = parseInt(flagBack);

            if (flag === 0) {
                await api.get("v1/protected/clientes/listarTodos", {
                    headers: headers
                }).then(function (response) {
                    setClientes(response.data)
                });
            } else if (flag === 1) {
                setClientes([]);

                await api.get("/v1/protected/retornardadoscliente/" + id_cliente, {
                    headers: headers
                }).then(function (response) {
                    setClienteSelecionado(response.data);

                    //listar instalacao
                    api.get("/v1/protected/cliente/instalacoes/listarporid/" + idInstalacao, {
                        headers: headers
                    }).then(function (response) {
                        setInstalacao(response.data);

                        setRamal(response.data.identificador_integrador + "0");




                    });
                });




            }

            //pgms
            try {
                const response = await api.get("v1/protected/modulopgm/listardisponiveis", {
                    headers: headers
                });
                setModulosPgms(response.data);

                //modulos sonoros
                try {
                    const response = await api.get("v1/protected/modulosonoro/listardisponiveis", {
                        headers: headers
                    });
                    setModulosSonoros(response.data);
                    try {
                        const response = await api.get("v1/protected/modulopgm/listardisponiveisporinstalacao/" + idInstalacao, {
                            headers: headers
                        });
                        setModulosPgmsAssociados(response.data);
                        try {
                            const response = await api.get("v1/protected/modulosonoro/listardisponiveisporinstalacao/" + idInstalacao, {
                                headers: headers
                            });
                            setModulosSonorosAssociados(response.data);
                            setLoading(false);
                        } catch (error) {
                            console.error('Erro ao buscar módulos sonoros:', error);
                        }

                        //gateways
                        try {
                            const response = await api.get("v1/protected/modulogateway/listardisponiveis", {
                                headers: headers
                            });
                            setModulosGateways(response.data);
                        } catch (error) {
                            console.error('Erro ao buscar módulos Gateway:', error);
                        }

                        //sentinel
                        try {
                            const response = await api.get("v1/protected/modulosentinel/listardisponiveis", {
                                headers: headers
                            });
                            setModulosSentinel(response.data);
                        } catch (error) {
                            console.error('Erro ao buscar módulos Sentinel:', error);
                        }

                    } catch (error) {
                        console.error('Erro ao buscar módulos PGM:', error);
                    }
                } catch (error) {
                    console.error('Erro ao buscar módulos sonoros:', error);
                }

            } catch (error) {
                console.error('Erro ao buscar módulos PGM:', error);
            }


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Clientes: " + _err)
        }
    }

    useEffect(() => {

        listarInformacoes();


    }, []);



    function handleSetInstalacao(instalacao) {
        setInstalacao(instalacao);
    }



    const [textoBusca, setTextoBusca] = useState("");

    useEffect(() => {

        if (textoBusca.length < 3) {
            return; // não busca com menos de 3 chars
        }

        const delayDebounce = setTimeout(() => {
            buscarInsumo(textoBusca);
        }, 500);

        return () => clearTimeout(delayDebounce);

    }, [textoBusca]);

    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }





    function handleSetInsumoSelecionado(insumo_) {
        try {
            const insumo = insumo_.insumo;
        } catch (_err) {
            setInsumoSelecionado(null);

            return;
        }

        setInsumoSelecionado(insumo_);
    }


    return (
        <ThemeProvider theme={theme}>
            <ThemeProviderV4 theme={themeV4}>
                <CssBaseline />
                <div style={{ backgroundColor: darkMode ? '#121212' : '#ffffff', minHeight: '100vh' }}>
                    <NavegadorGestao
                        BaseDados={true}
                        Projetos={true}
                        corFundo={darkMode ? '#121212' : 'white'}
                        travado={true}
                        corTexto={darkMode ? 'white' : 'black'}
                    />
                    <div style={{ paddingTop: 5 }} />


                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :
                        <Container >

                            <React.Fragment >
                                <Grid container spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <Grid
                                        item xs={12}
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent={"center"}
                                    >


                                        <Box style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', width: '100%', alignItems: 'center', }}>
                                            <AppBar position="static" >



                                                <Tabs
                                                    value={value}
                                                    indicatorColor="secondary"
                                                    textColor="inherit"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs example"
                                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                                >
                                                    <Tab label="Informações Iniciais" style={{ backgroundColor: darkMode ? '#121212' : '#1C1C1C', color: 'white' }} />


                                                </Tabs>

                                            </AppBar>

                                        </Box>
                                    </Grid>





                                    <Grid
                                        style={{ paddingTop: 30 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={10}
                                        >
                                            <Button style={{ margin: 5 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={salvar}
                                                disabled={botaoClicado}
                                            > Salvar  </Button>
                                        </Grid>

                                        <SwipeableViews
                                            index={value}
                                            onChangeIndex={handleChangeIndex}
                                            style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                        >

                                            <Grid
                                                value={value} index={0}
                                                style={{ paddingTop: 30 }}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                spacing={2}
                                            >



                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={12}
                                                    style={{ marginTop: 20 }}
                                                >
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={5}
                                                    >

                                                        <Autocomplete
                                                            id="select-ordem-servico"
                                                            options={clientes}
                                                            disableCloseOnSelect
                                                            getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
                                                            value={clienteSelecionado}
                                                            disabled={flagBack === 0 ? false : true}
                                                            onChange={handleCliente}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((cliente) => {
                                                                    const cotacaoText = returnDescricaoCliente(cliente).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label=" Cliente "
                                                                    multiline
                                                                    rows={3}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option) }} />
                                                            )}

                                                        />
                                                    </Grid>
                                                </Grid>




                                                {clienteSelecionado &&
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={12}
                                                        style={{ marginTop: 20 }}
                                                    >
                                                        <Grid
                                                            container
                                                            direction="column"
                                                            justifyContent="center"
                                                            align="center"
                                                            item xs={5}
                                                        >

                                                            <Autocomplete
                                                                id="select-instalacao"
                                                                options={[]}
                                                                disableCloseOnSelect
                                                                getOptionLabel={(instalacao) => returnDescricaoInstalacao(instalacao).replace(/<br \/>/g, '\n')}
                                                                value={instalacao}
                                                                disabled={flagBack === 0 ? false : true}
                                                                onChange={(e, v) => handleSetInstalacao(v)}
                                                                filterOptions={(options, { inputValue }) => {
                                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                    return options.filter((instalacao) => {
                                                                        const cotacaoText = returnDescricaoInstalacao(instalacao).toLowerCase();
                                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label=" Instalação "
                                                                        multiline
                                                                        minRows={3}
                                                                        InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                        inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                    />
                                                                )}
                                                                renderOption={(option) => (
                                                                    <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoInstalacao(option) }} />
                                                                )}

                                                            />
                                                        </Grid>
                                                    </Grid>
                                                }



                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={8}
                                                >

                                                    <Autocomplete
                                                        id="select-insumo"
                                                        options={insumos}
                                                        disableCloseOnSelect
                                                        getOptionLabel={(insumo) =>
                                                            returnDescricaoInsumo(insumo, isCliente).replace(/<br \/>/g, '\n')
                                                        }
                                                        value={insumoSelecionado}

                                                        onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                                        // 🔥 captura O TEXTO DIGITADO
                                                        onInputChange={(event, newInputValue) => {
                                                            setTextoBusca(newInputValue);
                                                        }}

                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((insumo) => {
                                                                const insumoText = returnDescricaoInsumo(insumo, isCliente).toLowerCase();
                                                                return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                            });
                                                        }}

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Insumo"
                                                                multiline
                                                                minRows={2}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        )}

                                                        renderOption={(option) => (
                                                            <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option, isCliente) }} />
                                                        )}
                                                    />
                                                </Grid>



                                                <Grid

                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={8}>

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={6}>
                                                            <TextField

                                                                id="modelo"
                                                                variant="standard"
                                                                name="modelo"
                                                                fullWidth
                                                                label="Modelo"
                                                                value={modelo}
                                                                onChange={e => setModelo(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>

                                                    </Grid>

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={6}>
                                                            <TextField

                                                                id="numeroSerie"
                                                                variant="standard"
                                                                name="numeroSerie"
                                                                fullWidth
                                                                label="Número de Serie"
                                                                value={numeroSerie}
                                                                onChange={e => setNumeroSerie(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>

                                                    </Grid>


                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={4}>
                                                            <TextField

                                                                id="ip"
                                                                variant="standard"
                                                                name="ip"
                                                                fullWidth
                                                                label="IP"
                                                                value={ip}
                                                                onChange={e => setIp(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>

                                                    </Grid>

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={4}>
                                                            <TextField

                                                                id="porta"
                                                                variant="standard"
                                                                name="porta"
                                                                fullWidth
                                                                label="Porta"
                                                                value={porta}
                                                                onChange={e => setPorta(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>

                                                    </Grid>

                                                </Grid>







                                                {insumoSelecionado && (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 70) &&
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                        spacing={2}
                                                    >
                                                        <Grid item xs={12} style={{ width: '100%', marginBottom: 20 }}>
                                                            <Autocomplete
                                                                id="select-modulo_pgm"
                                                                options={modulosPgms || []}
                                                                getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                                value={moduloPgmSelecionado}
                                                                getOptionSelected={(option, value) => true}
                                                                onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                                filterOptions={(options, { inputValue }) => {
                                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                    return options.filter((insumo) => {
                                                                        const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                                        return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Módulo PGM "
                                                                        multiline
                                                                        minRows={2}
                                                                        InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                        inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                    />
                                                                )}
                                                                renderOption={(option) => (
                                                                    <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                                )}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} style={{ width: '100%' }}>
                                                            <Autocomplete
                                                                id="select-modulo_sonoro_associado"
                                                                options={modulosSonorosAssociados}
                                                                getOptionLabel={(modulo) => returnDescricaoModuloSonoro(modulo).replace(/<br \/>/g, '\n')}
                                                                value={moduloSonoroSelecionado}
                                                                getOptionSelected={(option, value) => true}
                                                                onChange={(e, v) => setModuloSonoroSelecionado(v)}
                                                                filterOptions={(options, { inputValue }) => {
                                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                    return options.filter((insumo) => {
                                                                        const insumoText = returnDescricaoModuloSonoro(insumo).toLowerCase();
                                                                        return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Módulo Sonoro associado"
                                                                        multiline
                                                                        minRows={2}
                                                                        InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                        inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                    />
                                                                )}
                                                                renderOption={(option) => (
                                                                    <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloSonoro(option) }} />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                }




                                                {insumoSelecionado && insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 80 &&
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                        style={{ marginTop: 15, marginBottom: 15 }}
                                                    >
                                                        <FormControl fullWidth variant="outlined">
                                                            <InputLabel style={{ color: darkMode ? 'white' : 'black' }}>Protocolo da Câmera</InputLabel>
                                                            <Select
                                                                value={protocolo}
                                                                onChange={(e) => setProtocolo(parseInt(e.target.value, 10))}
                                                                label="Protocolo da Câmera"
                                                                style={{ color: darkMode ? 'white' : 'black' }}
                                                            >
                                                                <MenuItem value={0}>0 - Hikvision</MenuItem>
                                                                <MenuItem value={10}>10 - Intelbras</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 30 || insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 80) &&

                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >

                                                        <Autocomplete
                                                            id="select-modulo_sonoro"
                                                              options={insumoSelecionado?.insumo?.tipo_equipamento_area_tecnica === 80 ? (modulosSonorosAssociados || []) : (modulosSonoros || [])}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloSonoro(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloSonoroSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloSonoroSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloSonoro(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo Sonoro "
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloSonoro(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 5) &&

                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >

                                                        <Autocomplete
                                                            id="select-modulo_gateway"
                                                            options={modulosGateways}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloGateway(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloGatewaySelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloGatewaySelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloGateway(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo Gateway Sentinel "
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloGateway(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (insumoSelecionado.insumo.tipo_equipamento_area_tecnica === 8) &&

                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >

                                                        <Autocomplete
                                                            id="select-modulo_sentinel"
                                                            options={modulosSentinel}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloSentinel(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloSentinelSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloSentinelSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloSentinel(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo Sentinel "
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloSentinel(option) }} />
                                                            )}
                                                        />

                                                        <FormControl fullWidth style={{ marginTop: 20 }}>
                                                            <InputLabel id="posicao-label" style={{ color: darkMode ? 'white' : 'black' }}>Posição da Instalação do Sensor</InputLabel>
                                                            <Select
                                                                labelId="posicao-label"
                                                                id="posicao_instalacao"
                                                                value={posicaoInstalacao}
                                                                onChange={(e) => setPosicaoInstalacao(e.target.value)}
                                                                style={{ color: darkMode ? 'white' : 'black', textAlign: 'left' }}
                                                            >
                                                                <MenuItem value={0}>Horizontal</MenuItem>
                                                                <MenuItem value={1}>Vertical</MenuItem>
                                                            </Select>
                                                        </FormControl>

                                                        <TextField
                                                            id="delay_registro"
                                                            variant="standard"
                                                            name="delay_registro"
                                                            fullWidth
                                                            type="number"
                                                            label="Delay de Registro (em segundos)"
                                                            value={delayRegistro}
                                                            onChange={e => setDelayRegistro(e.target.value)}
                                                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            inputProps={{ style: { color: darkMode ? 'white' : 'black' }, min: 10 }}
                                                            style={{ marginTop: 20 }}
                                                        />
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (
                                                    (insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 0) ||
                                                    (parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 0)
                                                ) &&
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >
                                                        <Autocomplete
                                                            id="select-modulo_pgm"
                                                            options={modulosPgms || []}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloPgmSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo PGM"
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (
                                                    (insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80) ||
                                                    (parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80)
                                                ) &&
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                        style={{ marginTop: 15, marginBottom: 15 }}
                                                    >
                                                        <Autocomplete
                                                            id="select-modulo_pgm_camera"
                                                            options={(modulosPgmsAssociados && modulosPgmsAssociados.length > 0) ? modulosPgmsAssociados : (modulosPgms || [])}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloPgmSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo PGM associado à Câmera"
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                }

                                                {insumoSelecionado && (() => {
                                                    const tipo = parseInt(insumoSelecionado.insumo ? insumoSelecionado.insumo.tipo_equipamento_area_tecnica : insumoSelecionado.tipo_equipamento_area_tecnica, 10);
                                                    return tipo !== 0 && tipo !== 30 && tipo !== 70 && tipo !== 80;
                                                })() && (
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >
                                                        <Autocomplete
                                                            id="select-modulo_pgm"
                                                            options={(modulosPgmsAssociados && modulosPgmsAssociados.length > 0) ? modulosPgmsAssociados : (modulosPgms || [])}
                                                            getOptionLabel={(modulo) => returnDescricaoModuloPgm(modulo).replace(/<br \/>/g, '\n')}
                                                            value={moduloPgmSelecionado}
                                                            getOptionSelected={(option, value) => true}
                                                            onChange={(e, v) => setModuloPgmSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoModuloPgm(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Módulo PGM associado"
                                                                    multiline
                                                                    minRows={2}
                                                                    InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                    inputProps={{ ...params.inputProps, style: { ...params.inputProps.style, color: darkMode ? 'white' : 'black' } }}
                                                                />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div style={{ color: darkMode ? 'white' : 'black' }} dangerouslySetInnerHTML={{ __html: returnDescricaoModuloPgm(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                )}

                                                 {insumoSelecionado && (
                                                     (insumoSelecionado.insumo && parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 80) ||
                                                     (parseInt(insumoSelecionado.tipo_equipamento_area_tecnica, 10) === 80)
                                                 ) &&
                                                     <Grid
                                                         container
                                                         direction="row"
                                                         item xs={8}
                                                         spacing={2}
                                                         style={{ marginTop: 20, marginBottom: 20, border: "1px solid #ccc", padding: 15, borderRadius: 5 }}
                                                     >
                                                         <Grid item xs={12}>
                                                             <Typography variant="h6" style={{ color: darkMode ? "white" : "black" }}>Configurações de Câmera</Typography>
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                             <TextField fullWidth label="Usuário da Câmera" value={cameraUsuario} onChange={(e) => setCameraUsuario(e.target.value)} InputLabelProps={{ style: { color: darkMode ? "white" : "black" } }} inputProps={{ style: { color: darkMode ? "white" : "black" } }} />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                             <TextField fullWidth label="Senha da Câmera" type="password" value={cameraSenha} onChange={(e) => setCameraSenha(e.target.value)} InputLabelProps={{ style: { color: darkMode ? "white" : "black" } }} inputProps={{ style: { color: darkMode ? "white" : "black" } }} />
                                                         </Grid>
                                                         <Grid item xs={12}>
                                                             <TextField fullWidth label="Zona / Nome da Câmera (ex: Rua, Entrada)" value={cameraZona} onChange={(e) => setCameraZona(e.target.value)} InputLabelProps={{ style: { color: darkMode ? "white" : "black" } }} inputProps={{ style: { color: darkMode ? "white" : "black" } }} />
                                                         </Grid>
                                                         <Grid item xs={12}>
                                                             <FormControl fullWidth>
                                                                 <InputLabel style={{ color: darkMode ? "white" : "black" }}>Protocolo da Câmera</InputLabel>
                                                                 <Select value={protocolo} onChange={(e) => setProtocolo(parseInt(e.target.value, 10))} style={{ color: darkMode ? "white" : "black" }}>
                                                                     <MenuItem value={0}>0 - Hikvision</MenuItem>
                                                                     <MenuItem value={10}>10 - Intelbras</MenuItem>
                                                                 </Select>
                                                             </FormControl>
                                                             <FormControl fullWidth variant="outlined" style={{ marginTop: 15 }}>
                                                                 <InputLabel style={{ color: darkMode ? 'white' : 'black' }}>Canal de Gravação</InputLabel>
                                                                 <Select
                                                                     value={canalGravacao}
                                                                     onChange={(e) => setCanalGravacao(parseInt(e.target.value, 10))}
                                                                     label="Canal de Gravação"
                                                                     style={{ color: darkMode ? 'white' : 'black' }}
                                                                 >
                                                                     <MenuItem value={0}>CANAL 1 (STREAM PRINCIPAL - FULL HD)</MenuItem>
                                                                     <MenuItem value={1}>CANAL 2 (STREAM SECUNDÁRIO - SUBSTREAM)</MenuItem>
                                                                 </Select>
                                                             </FormControl>

                                                             <Grid container spacing={2} style={{ marginTop: 10 }}>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Temp. Mínima (°C / °F)"
                                                                         type="number"
                                                                         variant="outlined"
                                                                         value={temperaturaMinima}
                                                                         onChange={(e) => setTemperaturaMinima(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Temp. Máxima (°C / °F)"
                                                                         type="number"
                                                                         variant="outlined"
                                                                         value={temperaturaMaxima}
                                                                         onChange={(e) => setTemperaturaMaxima(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                             </Grid>

                                                             <Grid container spacing={2} style={{ marginTop: 10 }}>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Emissividade (ex: 0.95)"
                                                                         type="number"
                                                                         variant="outlined"
                                                                         value={emissividade}
                                                                         onChange={(e) => setEmissividade(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                                 <Grid item xs={6}>
                                                                     <FormControl fullWidth variant="outlined">
                                                                         <InputLabel style={{ color: darkMode ? 'white' : 'black' }}>Unidade de Temperatura</InputLabel>
                                                                         <Select
                                                                             value={unidadeTemperatura}
                                                                             onChange={(e) => setUnidadeTemperatura(parseInt(e.target.value, 10))}
                                                                             label="Unidade de Temperatura"
                                                                             style={{ color: darkMode ? 'white' : 'black' }}
                                                                         >
                                                                             <MenuItem value={0}>0 - Celsius (°C)</MenuItem>
                                                                             <MenuItem value={1}>1 - Fahrenheit (°F)</MenuItem>
                                                                         </Select>
                                                                     </FormControl>
                                                                 </Grid>
                                                             </Grid>

                                                             <Grid container spacing={2} style={{ marginTop: 10 }}>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Lista Negra LPR (Placas Alarme)"
                                                                         variant="outlined"
                                                                         value={listaNegraLpr}
                                                                         onChange={(e) => setListaNegraLpr(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Lista Branca LPR (Placas Autorizadas)"
                                                                         variant="outlined"
                                                                         value={listaBrancaLpr}
                                                                         onChange={(e) => setListaBrancaLpr(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                             </Grid>

                                                             <Grid container spacing={2} style={{ marginTop: 10 }}>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Preset de Alarme PTZ"
                                                                         type="number"
                                                                         variant="outlined"
                                                                         value={presetAlarme}
                                                                         onChange={(e) => setPresetAlarme(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                                 <Grid item xs={6}>
                                                                     <TextField
                                                                         fullWidth
                                                                         label="Velocidade PTZ (1 a 10)"
                                                                         type="number"
                                                                         variant="outlined"
                                                                         value={velocidadePtz}
                                                                         onChange={(e) => setVelocidadePtz(e.target.value)}
                                                                         InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                         inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                     />
                                                                 </Grid>
                                                             </Grid>
                                                         </Grid>
                                                     </Grid>
                                                 }






                                                {insumoSelecionado &&

                                                    (

                                                        (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 120)
                                                        ||
                                                        (parseInt(insumoSelecionado.insumo.tipo_equipamento_area_tecnica, 10) === 130)

                                                    )
                                                    &&

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={8}
                                                    >
                                                        <Grid item xs={4}>
                                                            <TextField

                                                                id="ramal"
                                                                variant="standard"
                                                                name="ramal"
                                                                fullWidth
                                                                label="Ramal"
                                                                value={ramal}
                                                                onChange={e => {
                                                                    const somenteNumeros = e.target.value.replace(/\D/g, '');
                                                                    setRamal(somenteNumeros);
                                                                }}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>


                                                        <Grid item xs={4}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={(e) => handleClickCriarRamal()}
                                                                startIcon={<SwapHorizIcon />}
                                                                style={{ margin: 10 }}
                                                            >
                                                                Criar Ramal
                                                            </Button>
                                                        </Grid>

                                                    </Grid>

                                                }





                                                <Grid item xs={12}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ margin: 15 }} >
                                                            <span style={{ fontSize: 22, textDecoration: 'underline' }}>Dados de Mapa: </span>
                                                        </Typography>
                                                    </Grid>

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={4}>
                                                            <TextField

                                                                id="nome_mapa"
                                                                variant="standard"
                                                                name="nome_mapa"
                                                                fullWidth
                                                                label="Nome Mapa"
                                                                value={nomeMapa}
                                                                onChange={e => setNomeMapa(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>



                                                    </Grid>

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12} spacing={2}
                                                    >
                                                        <Grid item xs={4}>
                                                            <TextField

                                                                id="localizacao"
                                                                variant="standard"
                                                                name="localizacao"
                                                                fullWidth
                                                                label="Localização"
                                                                value={localizacao}
                                                                onChange={e => setLocalizacao(e.target.value)}
                                                                InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                                inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            />
                                                        </Grid>

                                                    </Grid>





                                                    <Grid item xs={4}>
                                                        <TextField

                                                            id="latitude"
                                                            variant="standard"
                                                            name="latitude"
                                                            fullWidth
                                                            label="Latitude"
                                                            value={latitude}
                                                            onChange={e => setLatitude(e.target.value)}
                                                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}>
                                                        <TextField

                                                            id="longitude"
                                                            variant="standard"
                                                            name="longitude"
                                                            fullWidth
                                                            label="Longitude"
                                                            value={longitude}
                                                            onChange={e => setLongitude(e.target.value)}
                                                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>


                                                </Grid>


                                            </Grid>

                                            <Grid
                                                value={value}
                                                index={1}
                                                style={{ margin: 1, padding: 1, width: '100%' }}

                                            >

                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12} spacing={2}
                                                >
                                                    <Grid item xs={4}>
                                                        <TextField

                                                            id="ip"
                                                            variant="standard"
                                                            name="ip"
                                                            fullWidth
                                                            label="IP"
                                                            value={ip}
                                                            onChange={e => setIp(e.target.value)}
                                                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>

                                                </Grid>

                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12} spacing={2}
                                                >
                                                    <Grid item xs={4}>
                                                        <TextField

                                                            id="porta"
                                                            variant="standard"
                                                            name="porta"
                                                            fullWidth
                                                            label="Porta"
                                                            value={porta}
                                                            onChange={e => setPorta(e.target.value)}
                                                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                            inputProps={{ style: { color: darkMode ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>

                                                </Grid>

                                            </Grid>


                                        </SwipeableViews>


                                    </Grid>

                                </Grid>


                            </React.Fragment>


                        </Container>
                    }

                </div>
            </ThemeProviderV4>
        </ThemeProvider>
    );
}


